import { useMutation } from '@tanstack/react-query'
import type { CreateTestNotificationDto } from '@fp3/shared'
import { notificationsApi } from '../api/notificationsApi'

export const useCreateTestNotification = () => {
  return useMutation({
    mutationKey: ['notifications', 'create-test'],
    mutationFn: (dto: CreateTestNotificationDto) => notificationsApi.createTest(dto),
  })
}
